import { render, staticRenderFns } from "./NoticeHighlightSection.vue?vue&type=template&id=71d48d02&scoped=true"
import script from "./NoticeHighlightSection.vue?vue&type=script&lang=ts"
export * from "./NoticeHighlightSection.vue?vue&type=script&lang=ts"
import style0 from "./NoticeHighlightSection.vue?vue&type=style&index=0&id=71d48d02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d48d02",
  null
  
)

export default component.exports